import { render, staticRenderFns } from "./UpdateAvailable.vue?vue&type=template&id=10f92a2e&"
import script from "./UpdateAvailable.vue?vue&type=script&lang=js&"
export * from "./UpdateAvailable.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAvailable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports